import LoadingCard from "../../ProductCard/Loading";
import BounceyLoader from "../../Loading/index";

const Notice = () => {
  return (
    <div
      role="status"
      className="flex justify-center items-center w-[340px] border h-[110px] z-[5] bg-white absolute left-0 right-0 mx-auto rounded-[8px] shadow-[0px_0px_36px_0px_rgba(0,0,0,0.14)]"
    >
      <BounceyLoader />
      <div className="flex flex-col ml-[24px]">
        <span className="text-charcoal text-[24px] leading-[36px] font-bold">
          Finding Products
        </span>
        <p className="text-charcoal text-[14px] leading-[24px]">
          Your search may take a moment.
        </p>
      </div>
    </div>
  );
};

const Loading = () => {
  const MAX_SKELETON_LENGTH = 12;
  return (
    <div className="relative mt-8 flex justify-center">
      <Notice />
      <div className="max-w-[1440px] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 mt-[24px] mx-[8px] sm:mx-[24px] lg:mx-[40px] xxl:mx-[228px] mb-[32px]">
        {Array.from({ length: MAX_SKELETON_LENGTH })?.map(
          (_skeleton, index) => {
            return <LoadingCard key={index + 1} />;
          }
        )}
      </div>
    </div>
  );
};

export default Loading;
